module.exports = __webpack_public_path__ + "static/media/img_uniongroup_web.b11683dd.jpeg";